export default __webpack_public_path__ + "static/media/installAndroid.db31f2b6.png";